import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { IMainStep, IReduxState, IConfig, DeviceType } from './types';

import { setDeviceType } from './redux/actions/deviceType';

import { DESKTOP_BREAKPOINT } from './constants';

import { StepContainer } from './containers';
import { ResultView } from './components/ResultView';

import { steps } from './testData/steps';
import { GlobalAppStyle } from './styles/GlobalAppStyle';

interface IProps {
    step: number;
    deviceType: DeviceType;
    config: IConfig;
    setDeviceTypeConnect(value: DeviceType): void;
}

const BaseApp = ({
    step,
    deviceType,
    setDeviceTypeConnect,
    config,
}: IProps) => {
    useEffect(() => {
        if (!window) return;
        const screenWidth = innerWidth || screen.width;

        setDeviceTypeConnect(
            screenWidth < DESKTOP_BREAKPOINT ? 'mobile' : 'desktop'
        );
    }, []);

    if (!deviceType) return null;

    const totalSteps = Object.keys(steps).length;
    const flattenedSteps = ([] as IMainStep[]).concat(...Object.values(steps));
    const currentStep = flattenedSteps[step - 1];

    return (
        <GlobalAppStyle>
            {currentStep ? (
                <StepContainer>
                    <currentStep.component
                        onCloseButtonClick={config.onCloseButtonClick}
                        totalSteps={totalSteps}
                        {...currentStep.props}
                    />
                </StepContainer>
            ) : (
                <ResultView
                    totalSteps={totalSteps}
                    onCloseButtonClick={config.onCloseButtonClick}
                />
            )}
        </GlobalAppStyle>
    );
};

const mapStateToProps = (state: IReduxState) => ({
    step: state.step.main,
    deviceType: state.deviceType,
});

const mapDispatchToProps = {
    setDeviceTypeConnect: setDeviceType,
};

export const App = connect(
    mapStateToProps,
    mapDispatchToProps
)(BaseApp);
